var _rect, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoBj(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 24 25",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3.578,
    fill: "#FFC700",
    rx: 9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.646,
    r: 9,
    fill: "#FFC700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m12.264 4.396-.68.765c-.165.185-4.043 4.549-5.526 6.438a3.76 3.76 0 0 0-.768 1.75 3.4 3.4 0 0 0 .204 1.787c.417 1.026 1.325 1.765 2.488 2.027a5.5 5.5 0 0 0 2.103.049l-.394 1.197-.326.987h5.508l-.35-1-.39-1.11q.48.118.99.118c1.267 0 2.5-.553 3.22-1.445a3.43 3.43 0 0 0 .753-2.116 3.25 3.25 0 0 0-.746-2.124c-1.568-1.865-5.397-6.49-5.435-6.537z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.27 8.1q1.092 0 1.824.205.744.204 1.116.684.384.468.384 1.248 0 .504-.18.9-.18.384-.528.648-.336.252-.84.336v.06a2.8 2.8 0 0 1 .924.312q.408.216.648.636t.24 1.092q0 .78-.372 1.332-.36.54-1.044.828-.672.288-1.608.288H7.762V8.1zm.216 3.577q1.008 0 1.38-.324.384-.324.384-.96 0-.648-.456-.924t-1.452-.276H9.058v2.484zm-1.428 1.056v2.856h1.572q1.044 0 1.452-.408t.408-1.08q0-.408-.18-.72t-.612-.48q-.42-.168-1.152-.168zm4.851 6.288q-.3 0-.528-.048a2 2 0 0 1-.408-.108v-1.08q.192.048.408.084t.456.036q.3 0 .564-.12a.87.87 0 0 0 .432-.432q.156-.312.156-.876V8.1h1.296v8.316q0 .9-.3 1.476a1.8 1.8 0 0 1-.828.852q-.528.276-1.248.276"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBj);
export default __webpack_public_path__ + "static/media/IcoBJ.68e270f6451e5991b605934166d7be8c.svg";
export { ForwardRef as ReactComponent };